export const PAGOS_GENERALES_RECIBIDOS = "PAGOS_GENERALES_RECIBIDOS";
export const SET_PROPERTY_PAGO = "SET_PROPERTY_PAGO";
export const PAGOS_RECIBIDOS = "PAGOS_RECIBIDOS";
export const PAGO_TO_CANCEL = "PAGO_TO_CANCEL";
export const EDIT_PAGO = "EDIT_PAGO";
export const SAVE_PAGO = "SAVE_PAGO";
